
import React, { useEffect, useRef } from "react";
import { FaGoogle, FaStar } from "react-icons/fa";
import "../styles/testimonials.css";
import googleImg from "../images/g-logo.png";

const Testimonials = () => {
  const servicesRef = useRef(null);

  useEffect(() => {
    // Scroll reveal
    const revealElements =
      servicesRef.current?.querySelectorAll("[data-reveal]");

    const scrollReveal = () => {
      if (!revealElements) return;

      for (let i = 0; i < revealElements.length; i++) {
        const elementIsInScreen =
          revealElements[i].getBoundingClientRect().top <
          window.innerHeight / 1.15;

        if (elementIsInScreen) {
          revealElements[i].classList.add("revealed");
        } else {
          revealElements[i].classList.remove("revealed");
        }
      }
    };

    window.addEventListener("scroll", scrollReveal);
    scrollReveal();

    // Load SociableKIT Google Reviews script
    const scriptId = "sociablekit-google-reviews-script";

    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");

      script.id = scriptId;
      script.src =
        " https://widgets.sociablekit.com/google-reviews/widget.js";
      script.async = true;
      script.defer = true;

      document.body.appendChild(script);
    }

    

    return () => {
      window.removeEventListener("scroll", scrollReveal);
    };
  }, []);

  return (
    <section className="testimonials-section" ref={servicesRef}>
      <div className="testimonials-container">

        <div className="top-header featured__header">
          <span data-reveal>Customer Reviews</span>

          <h3 data-reveal>
            See Our Clients Testimonials
          </h3>

          <div className="line-wrapper" data-reveal>
            <div className="short-line"></div>
            <div className="short-line"></div>
          </div>
        </div>

    

        {/* SociableKIT Google Reviews */}
        <div className="google-widget-wrapper">
          <div
            className="sk-ww-google-reviews"
            data-embed-id="25716293"
          ></div>
        </div>
        

      </div>
    </section>
  );
};

export default Testimonials;
